/**
 * Cover Mode — shared add-on for all SHAPE configurators (rv, chaise, lshape, …)
 * uscushion.com · 2026-07
 *
 * Loaded by cushion-configurator-block.liquid ONLY when formula_type ends in
 * "_cover" (e.g. lshape_cover). It does two light things, so the shape JS files
 * stay almost untouched:
 *   1. The 0.7× price factor is delivered via window.__CC_COVER_FACTOR (set by an
 *      inline <script> in the Liquid, read inside each shape's price function).
 *   2. This file injects the "Cover only — no foam insert" notice so the customer
 *      understands they are ordering the fabric cover, not the whole cushion.
 *
 * The rectangular cover keeps its own dedicated file (cushion-configurator-cover.js)
 * and is NOT affected by this.
 */
(function () {
  'use strict';

  function injectNotice() {
    var wrap = document.getElementById('cc-configurator');
    if (!wrap) return;
    if (document.getElementById('cc-cover-notice')) return;

    var notice = document.createElement('div');
    notice.id = 'cc-cover-notice';
    notice.setAttribute('style',
      'margin:2px 16px 10px;padding:9px 12px;background:#F0EAD8;'
      + 'border:1px solid #D8C9A0;border-left:3px solid #6B5A2A;'
      + 'color:#4A4A47;font-size:11.5px;line-height:1.45;');
    notice.innerHTML = '<strong style="color:#2A2A28">Cover only — no foam insert.</strong> '
      + 'You’re ordering the replacement fabric cover for a cushion you already have. '
      + 'Enter your existing cushion’s size below.';

    // Place just under the dimensions hint, where customers look. Fall back to the
    // top of the configurator if that hint isn't present in this shape's layout.
    var hint = wrap.querySelector('.cc-sp-hint');
    if (hint && hint.parentNode) {
      hint.parentNode.insertBefore(notice, hint.nextSibling);
    } else {
      wrap.insertBefore(notice, wrap.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectNotice);
  } else {
    injectNotice();
  }
})();
